import SmoothScrollLink from "./smoothscroll";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import rmLogo from "../images/RM-logo.svg";
import { getMediaSrc } from "./helpers/preloadMedia";

const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

const ScrambleText = ({ text }) => {
  const [displayedText, setDisplayedText] = useState(text);
  const intervalRef = useRef(null);

  const scramble = () => {
    clearInterval(intervalRef.current);
    let iteration = 0;
    intervalRef.current = setInterval(() => {
      setDisplayedText(
        text
          .split("")
          .map((letter, index) =>
            index < iteration
              ? text[index]
              : letters[Math.floor(Math.random() * 26)],
          )
          .join(""),
      );
      if (iteration >= text.length) clearInterval(intervalRef.current);
      iteration += 1 / 5;
    }, 15);
  };

  useEffect(() => () => clearInterval(intervalRef.current), []);

  // The hidden copy of the real label locks the width; the scrambling text is
  // absolutely positioned on top, out of flow, so it can never shift siblings.
  return (
    <span
      onMouseEnter={scramble}
      style={{
        position: "relative",
        display: "inline-block",
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ visibility: "hidden" }} aria-hidden="true">
        {text}
      </span>
      <span style={{ position: "absolute", left: 0, top: 0 }}>
        {displayedText}
      </span>
    </span>
  );
};

const Navbar = () => {
  const location = useLocation();
  const isProjectPage = location.pathname.startsWith("/projects/");

  return (
    <nav>
      <div className="navbar">
        <a href="/">
          <div className="nav-logo">
            <img src={getMediaSrc(rmLogo)} id="nav-img"></img>
          </div>
        </a>
        <ul
          className="nav-links"
          style={isProjectPage ? { visibility: "hidden" } : undefined}
        >
          <li>
            <SmoothScrollLink to="#about">
              <ScrambleText text="ABOUT" />
            </SmoothScrollLink>
          </li>
          <li>
            <SmoothScrollLink to="#projects">
              <ScrambleText text="PROJECTS" />
            </SmoothScrollLink>
          </li>
          <li>
            <SmoothScrollLink to="#about">
              <ScrambleText text="CONTACT" />
            </SmoothScrollLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
